// extracted by mini-css-extract-plugin
export default {"user-icon-wrapper":"user-icon-wrapper--AAtt1","transparentTable":"transparentTable--SU2hQ"};